import { messagesService } from "@dv5/api"
import { ChangeWidgetData } from "./types"
import { StickyNoteData } from "@dv5/domain"

export const useStickyNoteUpdate = (
    canvasId: string,
    widgetId: string,
    data: StickyNoteData
) => {
    const updateData = (patchedPaths: string[], newData: Partial<StickyNoteData>) => {
        const updatedData = { ...data, ...newData }
        messagesService.send<ChangeWidgetData>("canvas.change-widget-data", {
            canvasId,
            widgetId,
            patchedPaths,
            data: updatedData as StickyNoteData,
        })
    }

    return { updateData }
}
